/**
 * @generated SignedSource<<e37f9f28ade826e7b1012df9bc2c383d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PartnerAtEstablishmentType = "blank" | "joinMidway" | "no" | "yes";
export type businessPartnerQuery$variables = {
  bmanTin?: string | null | undefined;
  refundHistoryId: string;
};
export type businessPartnerQuery$data = {
  readonly getSurveyBusinessAnswer: {
    readonly businessAnswer: ReadonlyArray<{
      readonly hasPartnerAtTheTimeOfEstablishment: PartnerAtEstablishmentType | null | undefined;
    }> | null | undefined;
    readonly result: boolean;
  };
  readonly getSurveyBusinessInfo: {
    readonly business: ReadonlyArray<{
      readonly ofbDt: string | null | undefined;
    }> | null | undefined;
  };
};
export type businessPartnerQuery = {
  response: businessPartnerQuery$data;
  variables: businessPartnerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bmanTin"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "refundHistoryId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "bmanTin",
    "variableName": "bmanTin"
  },
  {
    "kind": "Variable",
    "name": "refundHistoryId",
    "variableName": "refundHistoryId"
  }
],
v3 = [
  {
    "alias": null,
    "args": (v2/*: any*/),
    "concreteType": "SurveyBusinessInfoOutput",
    "kind": "LinkedField",
    "name": "getSurveyBusinessInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyBusinessInfo",
        "kind": "LinkedField",
        "name": "business",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ofbDt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v2/*: any*/),
    "concreteType": "SurveyBusinessAnswerOutput",
    "kind": "LinkedField",
    "name": "getSurveyBusinessAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyBusinessAnswer",
        "kind": "LinkedField",
        "name": "businessAnswer",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasPartnerAtTheTimeOfEstablishment",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "businessPartnerQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "businessPartnerQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "e631c117cf406d55983bc4efcb6785d4",
    "id": null,
    "metadata": {},
    "name": "businessPartnerQuery",
    "operationKind": "query",
    "text": "query businessPartnerQuery(\n  $refundHistoryId: String!\n  $bmanTin: String\n) {\n  getSurveyBusinessInfo(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {\n    business {\n      ofbDt\n    }\n  }\n  getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {\n    result\n    businessAnswer {\n      hasPartnerAtTheTimeOfEstablishment\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "30af97a08d0555e5bb1f427194c8e181";

export default node;
